import React, { useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../services/AuthContext";

import "../../styles/SignUp.css";
import logo from "../../assets/logo_ciano_50_ciano.png";
import toastStyles from "../../styles/Toast.module.css";

import Validation from "../../services/Validation";
import { toast } from "react-toastify";

function Login(props) {
  const navigate = useNavigate();
  const { setLogin } = useContext(AuthContext);

  async function onLogin(e) {
    e.preventDefault();

    console.log("E", e.target[0].value, e.target[1].value);

    if (Validation.isEmail(e.target[0].value)) {
      console.log("EMAIL", e.target[0].value);
    }

    try {
      let response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}users/login`,
        {
          ...(Validation.isEmail(e.target[0].value)
            ? { email: e.target[0].value }
            : { username: e.target[0].value }),
          password: e.target[1].value,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.error) {
        toast.error("Utente non esistente!!!", {
          onClose: () => {
            window.location.reload();
          },
          autoClose: 3000,
        });
        console.log("Error", response.data.error);
      } else if (response?.data?.status) {
        setLogin({
          username: response?.data?.username,
          email: response?.data?.email,
          status: response?.data?.status,
        });
        localStorage.setItem("AuthToken", response?.data?.authToken);
        navigate("/home");
      }
    } catch (error) {
      console.error("Network Error:", error);
      toast.error("Errore di rete. Riprova più tardi.");
    }
  }

  return (
    <form className="Entry" onSubmit={onLogin}>
      <div className={toastStyles.signUp}>
        <img src={logo} alt="" className={toastStyles.responsiveImage} />
        finstagram
      </div>
      <h1 style={{ color: "white" }}>LOG IN</h1>
      <div className="form">
        <label>Email:</label>
        <input type="text" />
      </div>
      <div className="form">
        <label>Password:</label>
        <input type="password" />
      </div>
      <div className="buttons">
        <button type="submit">Log In</button>
        <button type="button" onClick={() => props.changeToSignUp()}>
          Sign Up
        </button>
      </div>
    </form>
  );
}

export default Login;
